<template>
    <div class="background">
        <a-icon
            v-on:click="returnHome"
            class="back-button"
            type="left-circle" />
        <ve-histogram
            class="histogram-area"
            :events="chartEvents"
            :data="chartData"
            :colors="colors"
            :extend="extend">
        </ve-histogram>

        <NoScrollListView
            ref="listview"
            :titles="titles"
            :columnWidths="columnWidths"
            :columnCells="columnCells"
            :fetchCallback="fetchMachineList"
            :clickCallback="clickMachine"
            :bottomToFetch="false"
            :listWidth="100"
        />
    </div>
</template>

<script>
 import Vue from 'vue';
 import Background from "./Background.vue"
 import NoScrollListView from "./NoScrollListView.vue"
 import VCharts from 'v-charts'
 import message from "ant-design-vue/lib/message";

 import { parseDate, zeroFill } from "../util/date.js"
 import { formatSecondWithoutUnit } from "../util/time.js"

 Vue.use(VCharts)

 export default {
     name: 'LongVideo',
     data () {
         var that = this

         return {
             titles: ["序号", "下单日期", "货柜编号", "货柜名称", "货柜地址", "老板", "操作系统版本", "订单ID", "视频长度", "订单状态"],
             columnWidths: [5, 10, 5, 20, 15, 20, 10, 10, 5, 10],
             columnCells: [
                 { value: "",
                   style: ""
                 },
                 { value: "date",
                   style: "text-align: middle; padding-left: 10px;"
                 },
                 { value: "machineSerial",
                   style: "text-align: start; padding-left: 10px;"
                 },
                 { value: "machineName",
                   style: "text-align: start; padding-left: 30px;"
                 },
                 { value: "machineAddress",
                   style: "text-align: start; padding-left: 20px;"
                 },
                 { value: "bossName",
                   style: "text-align: end; padding-right: 20px;"
                 },
                 { value: "osVersion",
                   style: "text-align: end; padding-right: 20px;"
                 },
                 { value: "orderId",
                   style: "text-align: middle; padding-right: 20px;"
                 },
                 { value: "videoDuration",
                   style: "text-align: end; padding-right: 30px;"
                 },
                 { value: "orderStatus",
                   style: "text-align: middle; padding-right: 20px;"
                 },
             ],
             dateIndex: 0,
             extend: {
                 series: {
                     label: { show: true, position: "top" }
                 }
             },
             colors: ['#5295E4', '#c23531','#2f4554', '#61a0a8',
                      '#d48265', '#91c7ae','#749f83',
                      '#ca8622', '#bda29a','#6e7074',
                      '#546570', '#c4ccd3'],
             chartData: {
                 columns: ['日期', '长视频单数'],
                 rows: []
             },
             chartEvents: {
                 click: function (e) {
                     that.dateIndex = e.dataIndex
                     that.$refs.listview.research()
                 }
             },
         }
     },
     components: {
         Background,
         NoScrollListView
     },
     computed: {
     },
     mounted() {
         var url = process.env.VUE_APP_API_SERVER + '/statics/long-video-orders'
         var accessToken = localStorage.getItem('accessToken')
         var data = {
             num: this.downloadNumber
         }

         var that = this
         fetch(url, {
             method: "GET",
             headers: new Headers({
                 'Content-Type': 'application/json',
                 'Access-Token': accessToken
             })
         }).then(res => {
             if (!res.ok) { throw res }
             return res.json()
         }).catch(error => {
             console.log(error)
         }).then(response => {
             var rows = []

             for (var i = 0; i < response.length; i++) {
                 rows.push({
                     date: response[i].StartAt,
                     '日期': this.parseStatsDate(response[i].StartAt, i == 0),
                     '长视频单数': response[i].Amount
                 })
             }

             this.chartData.rows = rows
             this.dateIndex = rows.length - 1

             this.$refs.listview.research()
         })
     },
     methods: {
         fetchMachineList(offset, callback) {
             if (this.chartData.rows.length > 0) {
                 var date = new Date(Date.parse(this.chartData.rows[this.dateIndex].date))
                 var dateString = date.getFullYear() + zeroFill(date.getMonth() + 1, 2) + zeroFill(date.getDate(), 2)

                 var url = process.env.VUE_APP_API_SERVER + '/statics/long-video-orders/' + dateString
                 var accessToken = localStorage.getItem('accessToken')
                 var data = {
                     num: this.downloadNumber
                 }

                 var that = this
                 fetch(url, {
                     method: "GET",
                     headers: new Headers({
                         'Content-Type': 'application/json',
                         'Access-Token': accessToken
                     })
                 }).then(res => {
                     if (!res.ok) { throw res }
                     return res.json()
                 }).catch(error => {
                     console.log(error)
                 }).then(response => {
                     console.log(response)

                     var result = []
                     for (var i = 0; i < response.length; i++) {
                         result.push({
                             date: parseDate(response[i].Order.CreatedAt, true),
                             machineSerial: response[i].Machine.MachineSerialNum,
                             machineName: response[i].Machine.Name,
                             machineAddress: response[i].Machine.Address + response[i].Machine.AddressDetail,
                             bossName: response[i].Boss.Username,
                             bossPhone: response[i].Boss.Phone,
                             orderId: response[i].Order.OrderId,
                             orderStatus: response[i].Order.Status,
                             videoDuration: formatSecondWithoutUnit(response[i].MarkerOrder.Duration),
                             osVersion: response[i].BoxStatus.version
                         })
                     }

                     result = result.sort(function(a, b) {
                         if (a.machineSerial != b.machineSerial) {
                             return a.machineSerial.localeCompare(b.machineSerial)
                         } else {
                             return a.date.localeCompare(b.date)
                         }
                     })

                     callback(result)
                 })
             }
         },
         clickMachine(item) {
             sessionStorage.setItem("orderSearch", item.orderId)

             this.$router.push("/orderTracking")
         },
         returnHome() {
             this.$router.go(-1)
         },
         parseStatsDate(dateString, includeYear) {
             if (dateString == "0001-01-01T00:00:00Z") {
                 return ""
             } else if (dateString) {
                 var date = new Date(Date.parse(dateString))
                 var today = new Date()
                 var yesterday = new Date()
                 yesterday.setDate(yesterday.getDate() - 1)

                 if (date.toDateString() == today.toDateString()) {
                     return "今天"
                 } else if (date.toDateString() == yesterday.toDateString()) {
                     return "昨天"
                 } else {
                     if (includeYear) {
                         return date.getFullYear() + "-" + zeroFill(date.getMonth() + 1, 2) + "-" + zeroFill(date.getDate(), 2)
                     } else {
                         return zeroFill(date.getMonth() + 1, 2) + "-" + zeroFill(date.getDate(), 2)
                     }
                 }
             } else {
                 return ""
             }
         }
     },
 }
</script>

<style scoped>
 .background {
     width: 100%;
     height: 100%;
     background-color: #FFF;
 }

 .histogram-area {
     padding: 40px;
 }

 .back-button {
     position: absolute;
     top: 20px;
     left: 20px;
     color: #BBB;
     font-size: 40px;
     cursor: pointer;
     z-index: 1000;
 }

 .back-button:hover {
     color: #666;
 }
</style>
